// Portal › Kullanıcılar — firma set/işletme listelerinin yükleme durumu (SAF). Yönetici atama
// penceresi yalnız GEÇERLİ firmanın listeleri `ready` iken Admin kapsamı yazabilir: firma değişiminde
// önceki firmanın listeleri hemen düşer ("loading"), eski firmanın geç gelen yanıtı yok sayılır.

import type { ClientAdminSet, ClientEntity } from "@mahir/shared";

export interface ScopeLoad {
  status: "loading" | "ready" | "failed";
  sets: ClientAdminSet[];
  entities: ClientEntity[];
}

/** Yükleme başlangıcı (ilk açılış ve her firma değişimi): listeler boş, durum "loading". */
export const SCOPE_LOADING: ScopeLoad = { status: "loading", sets: [], entities: [] };

/**
 * Yanıtı uygular. `isCurrent=false` (bu arada firma değişti / yeniden yüklendi) → mevcut durum aynen;
 * `result=null` ya da `failed` → "failed" (liste yok — kapsam bilinmeden yazılmaz).
 */
export function applyScopeResult(
  cur: ScopeLoad,
  isCurrent: boolean,
  result: { sets: ClientAdminSet[]; entities: ClientEntity[]; failed: boolean } | null,
): ScopeLoad {
  if (!isCurrent) return cur;
  if (result === null || result.failed) return { status: "failed", sets: [], entities: [] };
  return { status: "ready", sets: result.sets, entities: result.entities };
}
